
import React, {
    useEffect,
    useMemo,
    useState,
  } from "react";
  
  import { HiOutlineFilm } from "react-icons/hi2";
  import { media } from "../../server";
  
  /* ============================================
     BUILD IMAGE SOURCES
  ============================================ */
  
  function getVideoImageSources(image) {
    if (!image || typeof image !== "string") {
      return [];
    }
  
    const original = image.trim().replace(/\\/g, "/");
  
    if (!original) return [];
  
    // External URL
    if (/^(https?:\/\/|data:image\/|blob:)/i.test(original)) {
      return [original];
    }
  
    const path = original.replace(/^\/+/, "");
  
    // Support older PNG/JPG names
    const webpPath = path.replace(
      /\.(png|jpe?g)$/i,
      ".webp"
    );
  
    const paths = [...new Set([webpPath, path])];
  
    const base = String(media || "").replace(/\/+$/, "");
  
    const sources = paths.flatMap((filePath) => {
      const filename = filePath.split("/").pop();
  
      return [
        // Backend media directory
        base
          ? `${base}/${filePath}`
          : `/${filePath}`,
  
        // Frontend public/images
        `/images/${filename}`,
  
        // Frontend public root
        `/${filePath}`,
      ];
    });
  
    return [...new Set(sources)];
  }
  
  /* ============================================
     REUSABLE VIDEO THUMBNAIL
  ============================================ */
  
  function VideoThumbnail({
    image,
    alt = "",
    className = "",
    priority = false,
  }) {
    const sources = useMemo(
      () => getVideoImageSources(image),
      [image]
    );
  
    const [sourceIndex, setSourceIndex] = useState(0);
  
    useEffect(() => {
      setSourceIndex(0);
    }, [image]);
  
    const currentSource = sources[sourceIndex];
  
    return (
      <div
        className={`
          relative overflow-hidden
          bg-[#142C40]
          ${className}
        `}
      >
        {currentSource ? (
          <img
            key={currentSource}
            src={currentSource}
            alt={alt}
            loading={priority ? "eager" : "lazy"}
            decoding="async"
            onError={() => {
              setSourceIndex((previous) => previous + 1);
            }}
            className="
              absolute inset-0
              h-full w-full
              object-cover object-center
  
              transition-transform
              duration-700 ease-out
  
              group-hover:scale-105
            "
          />
        ) : (
          <div
            className="
              absolute inset-0
              flex items-center justify-center
  
              bg-gradient-to-br
              from-[#294961]
              via-[#18354A]
              to-[#0B1726]
            "
          >
            {/* Decorative circles */}
            <div
              aria-hidden="true"
              className="
                absolute -end-16 -top-16
                h-56 w-56 rounded-full
                border border-white/10
              "
            />
  
            <div
              aria-hidden="true"
              className="
                absolute -start-16 -bottom-20
                h-52 w-52 rounded-full
                border border-white/10
              "
            />
  
            <HiOutlineFilm
              size={65}
              aria-hidden="true"
              className="relative text-[#D7B77F]/55"
            />
          </div>
        )}
      </div>
    );
  }
  
  export default VideoThumbnail;
  